<template>
  <div>
    <section class="page-content">
      <form action @submit.prevent="next">
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-12">
              <label for class="orep-label">
                <span class="mr-1">13.</span>
                In the past year, what was the average value of properties:
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-6">
                  <label for class="orep-label mb-0">
                    <span class="mr-1">a.</span> Sold
                  </label>
                  <div class="d-flex align-items-center py-2">
                    <label class="orep-label mb-0 mr-2">$</label>
                  <input
                    type="text"
                    name="averageValueOfPropertiesSoldByApplicant"
                    v-model="standardApplication.averageValueOfPropertiesSoldByApplicant"
                    class="orep-text-input w-100"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                  >
                  <span
                    v-show="errors.has('averageValueOfPropertiesSoldByApplicant')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('averageValueOfPropertiesSoldByApplicant') | filterText }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label for class="orep-label mb-0">
                    <span class="mr-1">b.</span> appraised (if applicable):
                  </label>
                  <div class="d-flex align-items-center py-2">
                    <label class="orep-label mb-0 mr-2">$</label>
                  <input
                    type="text"
                    name="averageValueOfPropertiesAppraisedByApplicant"
                    v-model="standardApplication.averageValueOfPropertiesAppraisedByApplicant"
                    class="orep-text-input w-100"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                  >
                  <span
                    v-show="errors.has('averageValueOfPropertiesAppraisedByApplicant')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('averageValueOfPropertiesAppraisedByApplicant') | filterText }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <label class="orep-label">
            <span class="mr-1">14.</span>What percentage of residential transactions included a:
          </label>
          <div class="flex">
            <div class="col-md-9">
              <label for class="orep-label"  style="text-align: right;">
                I am not a real estate agent/broker.
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="checkbox"
                      name="realEstateAgentBroker"
                      v-model="state.standardApplication.realEstateAgentBroker"
                      class="orep-radio"
                      @change="validateBeforeSubmitCheck($event)"
                    >
                    <span class="radio-span">N/A</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center py-2"  v-if="state.standardApplication.realEstateAgentBroker === false">
            <label class="mb-0" style="width: 300px;">a. Signed property disclosure form?</label>
            <input
              type="text"
              name="signedPropertyDisclosureForm"
              v-model="standardApplication.signedPropertyDisclosureForm"
              class="orep-text-input ml-3 mr-1"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
              style="width: 50px;"
            >
            <label class="mb-0 mr-4">%</label>
            <span
              v-show="errors.has('signedPropertyDisclosureForm')"
              class="help is-danger form-errors text-danger"
            >{{ errors.first('signedPropertyDisclosureForm') | filterText }}</span>
          </div>
          <div class="d-flex align-items-center py-2"  v-if="state.standardApplication.realEstateAgentBroker === false">
            <label class="mb-0" style="width: 300px;">b. Home warranty program?</label>
            <input
              type="text"
              name="homeWarrantyProgram"
              v-model="standardApplication.homeWarrantyProgram"
              class="orep-text-input ml-3 mr-1"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
              style="width: 50px;"
            >
            <label class="mb-0 mr-4">%</label>
            <span
              v-show="errors.has('homeWarrantyProgram')"
              class="help is-danger form-errors text-danger"
            >{{ errors.first('homeWarrantyProgram') | filterText }}</span>
          </div>
          <div class="d-flex align-items-center py-2"  v-if="state.standardApplication.realEstateAgentBroker === false">
            <label class="mb-0" style="width: 300px;">c. Home inspection or written waiver?</label>
            <input
              type="text"
              name="homeInspectionOrWrittenWaiver"
              v-model="standardApplication.homeInspectionOrWrittenWaiver"
              class="orep-text-input ml-3 mr-1"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
              style="width: 50px;"
            >
            <label class="mb-0 mr-4">%</label>
            <span
              v-show="errors.has('homeInspectionOrWrittenWaiver')"
              class="help is-danger form-errors text-danger"
            >{{ errors.first('homeInspectionOrWrittenWaiver') | filterText }}</span>
          </div>
        </article>
        <article class="input-section form-section">
          <label class="orep-label">
            <span class="mr-1">15.</span>What percentage of transactions involve acting as a:
          </label>
          <div class="flex">
            <div class="col-md-9">
              <label for class="orep-label"  style="text-align: right;">
                I am not a real estate agent/broker.
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="checkbox"
                      name="realEstateAgentBroker"
                      v-model="state.standardApplication.realEstateAgentBroker"
                      class="orep-radio"
                      @change="validateBeforeSubmitCheck($event)"
                    >
                    <span class="radio-span">N/A</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center py-2" v-if="state.standardApplication.realEstateAgentBroker === false">
            <label class="mb-0" style="width: 300px;">a. Dual Agent?</label>
            <input
              type="text"
              name="transactionInvolveActingDualAgent"
              v-model="standardApplication.transactionInvolveActingDualAgent"
              class="orep-text-input ml-3 mr-1"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
              style="width: 50px;"
            >
            <label class="mb-0 mr-4">%</label>
            <span
              v-show="errors.has('transactionInvolveActingDualAgent')"
              class="help is-danger form-errors text-danger"
            >{{ errors.first('transactionInvolveActingDualAgent') | filterText }}</span>
          </div>
          <div class="d-flex align-items-center py-2"  v-if="state.standardApplication.realEstateAgentBroker === false">
            <label class="mb-0" style="width: 300px;">b. Intermediary?</label>
            <input
              type="text"
              name="transactionInvolveActingIntermediary"
              v-model="standardApplication.transactionInvolveActingIntermediary"
              class="orep-text-input ml-3 mr-1"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
              style="width: 50px;"
            >
            <label class="mb-0 mr-4">%</label>
            <span
              v-show="errors.has('transactionInvolveActingIntermediary')"
              class="help is-danger form-errors text-danger"
            >{{ errors.first('transactionInvolveActingIntermediary') | filterText }}</span>
          </div>
          <div class="d-flex align-items-center py-2" v-if="state.standardApplication.realEstateAgentBroker === false">
            <label class="mb-0" style="width: 300px;">c. Transactional broker?</label>
            <input
              type="text"
              name="transactionInvolveActingBroker"
              v-model="standardApplication.transactionInvolveActingBroker"
              class="orep-text-input ml-3 mr-1"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
              style="width: 50px;"
            >
            <label class="mb-0 mr-4">%</label>
            <span
              v-show="errors.has('transactionInvolveActingBroker')"
              class="help is-danger form-errors text-danger"
            >{{ errors.first('transactionInvolveActingBroker') | filterText }}</span>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">16.</span>
                Has any member of your firm been involved in asset or property preservation services including any
                incidental repair work on bank owned properties within the last 3 year period?
              </label>
            </div>
            <div v-if="!state.standardApplication.realEstateAgentBroker" class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="hasAnyMemberInvolvedInPropertyPreservation"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.hasAnyMemberInvolvedInPropertyPreservation"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="hasAnyMemberInvolvedInPropertyPreservation"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.hasAnyMemberInvolvedInPropertyPreservation"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('hasAnyMemberInvolvedInPropertyPreservation')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('hasAnyMemberInvolvedInPropertyPreservation') | filterText }}</span>
            </div>
          </div>
          <div class="flex">
            <div class="col-md-9">
              <label for class="orep-label"  style="text-align: right;">
                I am not a real estate agent/broker.
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="checkbox"
                      name="realEstateAgentBroker"
                      v-model="state.standardApplication.realEstateAgentBroker"
                      class="orep-radio"
                      @change="validateBeforeSubmitCheck($event)"
                    >
                    <span class="radio-span">N/A</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">17.</span>
                Has any member of your firm been involved in property rehabilitation services on bank owned properties
                within the last 3 year period?
              </label>
            </div>
            <div v-if="!state.standardApplication.realEstateAgentBroker" class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="hasAnyMemberInvolvedInPropertyRehabilitation"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.hasAnyMemberInvolvedInPropertyRehabilitation"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="hasAnyMemberInvolvedInPropertyRehabilitation"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.hasAnyMemberInvolvedInPropertyRehabilitation"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('hasAnyMemberInvolvedInPropertyRehabilitation')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('hasAnyMemberInvolvedInPropertyRehabilitation') | filterText }}</span>
            </div>

          </div>
          <div class="flex" v-if="standardApplication.hasAnyMemberInvolvedInPropertyRehabilitation == 'true' || standardApplication.hasAnyMemberInvolvedInPropertyPreservation== 'true'">
            <div class="col-md-9">
              <label for class="orep-label text-danger">
                If Yes to question 16 or 17, were all such repairs contracted by you done by a licensed contractor? (Email: <a href="mailto:info@orep.org" target="_top">info@orep.org</a>)
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="wereAllRepairsContractedByLicensed"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.wereAllRepairsContractedByLicensed"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="wereAllRepairsContractedByLicensed"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.wereAllRepairsContractedByLicensed"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('wereAllRepairsContractedByLicensed')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('wereAllRepairsContractedByLicensed') | filterText }}</span>
            </div>
          </div>
          <div class="flex">
            <div class="col-md-9">
              <label for class="orep-label"  style="text-align: right;">
                I am not a real estate agent/broker.
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="checkbox"
                      name="realEstateAgentBroker"
                      v-model="state.standardApplication.realEstateAgentBroker"
                      class="orep-radio"
                      @change="validateBeforeSubmitCheck($event)"
                    >
                    <span class="radio-span">N/A</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">18.</span>
                For any bank owned properties where you represent the buyer, do you advise the buyer in writing to have
                the property inspected by a licensed and insured home inspector prior to purchase?
              </label>
            </div>
            <div v-if="!state.standardApplication.realEstateAgentBroker" class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doYouHaveAdvisedBuyerForPropertyInspection"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.doYouHaveAdvisedBuyerForPropertyInspection"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doYouHaveAdvisedBuyerForPropertyInspection"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.doYouHaveAdvisedBuyerForPropertyInspection"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('doYouHaveAdvisedBuyerForPropertyInspection')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('doYouHaveAdvisedBuyerForPropertyInspection') | filterText }}</span>
            </div>
          </div>
          <div class="flex">
            <div class="col-md-9">
              <label for class="orep-label"  style="text-align: right;">
                I am not a real estate agent/broker.
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="checkbox"
                      name="realEstateAgentBroker"
                      v-model="state.standardApplication.realEstateAgentBroker"
                      class="orep-radio"
                      @change="validateBeforeSubmitCheck($event)"
                    >
                    <span class="radio-span">N/A</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">19.</span>
                Has any member of your firm engaged in acquiring the properties or deeds of financially
                distressed homeowners, including sale – leaseback agreements within the last 3 year period?
              </label>
            </div>
            <div v-if="!state.standardApplication.realEstateAgentBroker" class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="hasAnyMemberEngagedInAcquiringProperties"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.hasAnyMemberEngagedInAcquiringProperties"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="hasAnyMemberEngagedInAcquiringProperties"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.hasAnyMemberEngagedInAcquiringProperties"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('hasAnyMemberEngagedInAcquiringProperties')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('hasAnyMemberEngagedInAcquiringProperties') | filterText }}</span>
            </div>
          </div>
          <div class="flex">
            <div class="col-md-9">
              <label for class="orep-label"  style="text-align: right;">
                I am not a real estate agent/broker.
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="checkbox"
                      name="realEstateAgentBroker"
                      v-model="state.standardApplication.realEstateAgentBroker"
                      class="orep-radio"
                      @change="validateBeforeSubmitCheck($event)"
                    >
                    <span class="radio-span">N/A</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">20.</span>
                Has the applicant engaged in any eviction services on pre-foreclosed or bank owned properties within the
                last 3 years?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="hasApplicantEngagedInAnyEviction"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.hasApplicantEngagedInAnyEviction"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="hasApplicantEngagedInAnyEviction"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.hasApplicantEngagedInAnyEviction"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('hasApplicantEngagedInAnyEviction')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('hasApplicantEngagedInAnyEviction') | filterText }}</span>
            </div>

          </div>
          <div class="row" v-if="standardApplication.hasApplicantEngagedInAnyEviction == true || standardApplication.hasApplicantEngagedInAnyEviction === 'true'">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label text-danger">
                If Yes, was the preparation, filing and service of the eviction complaint and obtaining the eviction
                judgment handled by an attorney?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="wasPreparationEvictionJudgmentHandledByAttorney"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.wasPreparationEvictionJudgmentHandledByAttorney"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="wasPreparationEvictionJudgmentHandledByAttorney"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.wasPreparationEvictionJudgmentHandledByAttorney"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('wasPreparationEvictionJudgmentHandledByAttorney')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('wasPreparationEvictionJudgmentHandledByAttorney') | filterText }}</span>
            </div>

          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">21.</span>
                Is any client responsible for more than 25% of the applicant’s annual income?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="clientResponsibleForMoreThan25PercentAnnualIncome"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.clientResponsibleForMoreThan25PercentAnnualIncome"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="clientResponsibleForMoreThan25PercentAnnualIncome"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.clientResponsibleForMoreThan25PercentAnnualIncome"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('clientResponsibleForMoreThan25PercentAnnualIncome')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('clientResponsibleForMoreThan25PercentAnnualIncome') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">22.</span>
                Does the firm perform or intend to perform professional services for REITS or property syndications?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doesFirmPerformSyndication"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.doesFirmPerformSyndication"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doesFirmPerformSyndication"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.doesFirmPerformSyndication"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('doesFirmPerformSyndication')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('doesFirmPerformSyndication') | filterText }}</span>
            </div>
          </div>
          <div class="d-flex align-items-center py-2" v-if="standardApplication.doesFirmPerformSyndication == true || standardApplication.doesFirmPerformSyndication === 'true'">

            <div class="col-md-9">
              <label class="mb-0  text-danger">If Yes, what is the percentage of the gross commission income derived from these services?</label>
            </div>
            <input
              type="text"
              name="grossCommissionIncomeByFirmPerformSyndications"
              v-model="standardApplication.grossCommissionIncomeByFirmPerformSyndications"
              class="orep-text-input ml-0 mr-1"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
              style="width: 50px;"
            >
            <label class="mb-0 mr-4">%</label>
            <span
              v-show="errors.has('grossCommissionIncomeByFirmPerformSyndications')"
              class="help is-danger form-errors text-danger"
            >{{ errors.first('grossCommissionIncomeByFirmPerformSyndications') | filterText }}</span>
          </div>
        </article>
        <article class="input-section form-section">
          <label class="orep-label">
            <span class="mr-2">23.</span>
            During the past 5 years:
          </label>
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">a.</span>
                Has the applicant been involved in any merger, acquisition, or consolidation?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="duringFiveYearsApplicantInvolvedInMerger"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.duringFiveYearsApplicantInvolvedInMerger"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="duringFiveYearsApplicantInvolvedInMerger"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.duringFiveYearsApplicantInvolvedInMerger"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('duringFiveYearsApplicantInvolvedInMerger')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('duringFiveYearsApplicantInvolvedInMerger') | filterText }}</span>

            </div>

          </div>
          <div class="col-md-auto d-flex flex-column">
          <p v-show="standardApplication.duringFiveYearsApplicantInvolvedInMerger === 'true' || standardApplication.duringFiveYearsApplicantInvolvedInMerger == 'true'" class="text-danger">
            If Yes, provide details on a separate sheet and include any name changes for the firm. (Email: <a href="mailto:info@orep.org" target="_top">info@orep.org</a>)
          </p>
          </div>
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">b.</span>
                Has any principal, partner, director, officer, or professional of the applicant performed professional
                services for any other business which the applicant has any ownership or managerial interest?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="duringFiveYearsApplicantHasPrincipal"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.duringFiveYearsApplicantHasPrincipal"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="duringFiveYearsApplicantHasPrincipal"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.duringFiveYearsApplicantHasPrincipal"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('duringFiveYearsApplicantHasPrincipal')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('duringFiveYearsApplicantHasPrincipal') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column">
            <p v-show="standardApplication.duringFiveYearsApplicantHasPrincipal === 'true' || standardApplication.duringFiveYearsApplicantHasPrincipal == 'true'" class="text-danger">
              If Yes, provide details on a separate sheet. (Email: <a href="mailto:info@orep.org" target="_top">info@orep.org</a>)
            </p>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">24.</span>
                Does the applicant transact business in multiple states or outside of the United States?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doesApplicantControlBusinessInMultipleStates"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.doesApplicantControlBusinessInMultipleStates"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doesApplicantControlBusinessInMultipleStates"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.doesApplicantControlBusinessInMultipleStates"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('doesApplicantControlBusinessInMultipleStates')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('doesApplicantControlBusinessInMultipleStates') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column">
            <p v-show="standardApplication.doesApplicantControlBusinessInMultipleStates === 'true' || standardApplication.doesApplicantControlBusinessInMultipleStates == 'true'" class="text-danger">
              If Yes, provide details on a separate sheet, including the percent (%) of total gross revenues from each
              state or country. (Email: <a href="mailto:info@orep.org" target="_top">info@orep.org</a>)
            </p>
          </div>
        </article>
        <article class="input-section form-section">
          <label class="orep-label">
            <span class="mr-2">25.</span>
            After inquiry, is the applicant, or anyone to whom this insurance will apply, aware of any:
          </label>
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">a.</span>
                Professional Liability claim made against them in the past 5 years?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="whomInsuranceApplyClaimMadeBy"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.whomInsuranceApplyClaimMadeBy"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="whomInsuranceApplyClaimMadeBy"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.whomInsuranceApplyClaimMadeBy"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('whomInsuranceApplyClaimMadeBy')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('whomInsuranceApplyClaimMadeBy') | filterText }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">b.</span>
                Act or omissions in the performance of professional service for others which might reasonably be
                expected to be the basis of a claim or suit against them?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="whomInsuranceApplyActOrOmissions"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.whomInsuranceApplyActOrOmissions"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="whomInsuranceApplyActOrOmissions"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.whomInsuranceApplyActOrOmissions"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('whomInsuranceApplyActOrOmissions')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('whomInsuranceApplyActOrOmissions') | filterText }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">c.</span>
                Complaint, disciplinary action or investigation by any regulatory authority within the last 5 years?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="whomInsuranceApplyToComplaint"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.whomInsuranceApplyToComplaint"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="whomInsuranceApplyToComplaint"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.whomInsuranceApplyToComplaint"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('whomInsuranceApplyToComplaint')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('whomInsuranceApplyToComplaint') | filterText }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">d.</span>
                Changes in any claims previously reported on past applications?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="whomInsuranceApplyToReportedChanges"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.whomInsuranceApplyToReportedChanges"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="whomInsuranceApplyToReportedChanges"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="standardApplication.whomInsuranceApplyToReportedChanges"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('whomInsuranceApplyToReportedChanges')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('whomInsuranceApplyToReportedChanges') | filterText }}</span>
            </div>
          </div>
        </article>
      </form>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'standard-application-2'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToOne()"></button>
              <button class="pagination-dots" @click="prev()"></button>
              <span class="pagination-dots pagination-current"></span>
              <button class="pagination-dots" @click="navigateToNext('standard-application-4')" :disabled="!state.pageThreeIsValid"></button>
              <button class="pagination-dots" @click="navigateToNext('standard-application-5')" :disabled="!state.pageThreeIsValid || !state.pageFourIsValid"></button>
              <button
                class="pagination-dots"
                @click="navigateToNext('standard-application-6')"
                :disabled="!state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('standard-application-7')"
                  :disabled="!state.pageSixIsValid">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('standard-application-8')"
                  :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid || !state.pageSixIsValid || !state.pageSevenIsValid">
              </button>
            </article>
            <button
              type="submit"
              :disabled="!state.pageThreeIsValid"
              :class="{submitDisabled: !state.pageThreeIsValid}"
              class="next-btn mont spaced pull-right"
              @click="navigateToNext('standard-application-4')"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "standard-application-3",
  computed: {
    standardApplication() {
      return this.$store.state.standardApplication.standardApplication;
    },
    state() {
      return this.$store.state.standardApplication;
    },
    errorMsg() {
      return this.$store.state.standardApplication.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    desiredCoverage(event) {
      if(!this.standardApplication.limitOfCoverages.find(coverage => coverage === event.target.value)) {
        if (this.standardApplication.limitOfCoverages.length < 2) {
          this.standardApplication.limitOfCoverages.push(event.target.value);
        } else {
          this.$notify({
            group: 'error',
            type: 'warning',
            title: 'Warning',
            text: 'You can select up to 2 coverages.'
          });
        }
      } else {
        this.standardApplication.limitOfCoverages = this.standardApplication.limitOfCoverages.filter(coverage => coverage !== event.target.value);
      }
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    prev() {
      this.$router.push({
        name: "standard-application-2"
      });
    },

    navigateToOne() {
      this.$router.push({
        name: "standard-application-1"
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageThreeIsValid = true;
          return;
        }
        this.state.pageThreeIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.state.standardApplication.realEstateAgentBroker === true){
            this.state.pageTwoIsValid = true;
          }
          else {
            this.state.pageTwoIsValid = false;
            this.validateBeforeSubmit();
          }
          return;
        }
        this.state.pageTwoIsValid = true;

      });
    },
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
</style>

